// Module
var code = `<div header-bar>
    <header-bar-title tid="makeAPaymentLabel" id="makeAPaymentLabel" >Make A Payment</header-bar-title>
</div>

<app-page-content [showWebFooter]="true"
                  [usePagePadding]="true"
                  [pmcId]="paymentRequest.property.hoa.pmc.couponId"
                  [hoaId]="paymentRequest.property.hoa.couponId"
                  [propertyId]="paymentRequest.property.couponId">
    <app-cobrand-header [property]="paymentRequest.property.nickname"
                        [manager]="paymentRequest.property.hoa.pmc.name"
                        [association]="paymentRequest.property.hoa.name"
                        [makePayment]="true">
    </app-cobrand-header>
    <div class="HOA-container">
        <div class="HOA-container__header">
            <h1 tid="paymentSummaryLabel" class="HOA-container__header-text">Review and Submit Payment</h1>
        </div>
        <div class="HOA-container__content HOA-splash--center ">
            <div class="HOA-font-light u-pB7">
                <!-- CARD Authorizing copy -->
                <div *ngIf="paymentRequest.paymentMethod.routingNumber == null">
                    <div tid="authorizingText"
                         id="authorizingText"
                         class="u-pB3">
                        You are authorizing a payment to be made on {{paymentRequest.paymentDate.formattedFullDate}}
                        from your card ending in {{paymentRequest.paymentMethod.maskedId}} for the
                        <span class="u-whitespace-nowrap">amount of</span>
                    </div>
                    <div class="u-pB7">
                        <div>
                            <a [routerLink]="guestPaymentCardState" tid="editPaymentAmountDollar" id="editPaymentAmountDollar">
                                <span tid="totalPaymentAmount" id="totalPaymentAmount" class="HOA-link HOA-make-payment-amount-total">
                                    {{paymentRequest.payment.totalPaymentAmount | currency}}</span>
                            </a>
                        </div>
                        <a class="u-pT2 u-inlineBlock"
                           tid="editPaymentAmountEdit"
                           id="editPaymentAmountEdit"
                           [routerLink]="guestPaymentCardState">
                            Edit
                        </a>
                    </div>
                </div>

                <!-- ACH Authorizing copy -->
                <div *ngIf="paymentRequest.paymentMethod.routingNumber != null">
                    <div tid="authorizingText" id="authorizingText" class="u-pB3">
                        You are authorizing a payment to be made on {{paymentRequest.paymentDate.formattedFullDate}}
                        from your bank account ending in {{ paymentRequest.paymentMethod.maskedId }} for the
                        <span class="u-whitespace-nowrap">
                            amount of
                        </span>
                    </div>
                    <div class="u-pB7">
                        <div>
                            <a [routerLink]="guestPaymentCheckState"
                               tid="editPaymentAmountDollar"
                               id="editPaymentAmountDollar">
                                <span tid="totalPaymentAmount"
                                      id="totalPaymentAmount"
                                      class="HOA-link HOA-make-payment-amount-total">
                                    {{paymentRequest.payment.totalPaymentAmount | currency}}
                                </span>
                            </a>
                        </div>
                        <a class="u-pT2 u-inlineBlock"
                           tid="editPaymentAmountEdit"
                           id="editPaymentAmountEdit"
                           [routerLink]="guestPaymentCheckState">
                            Edit
                        </a>
                    </div>
                </div>

                <div class="u-pB1">Property Address</div>
                <div class="u-pB2 HOA-font-normal">
                    <div class="u-block HOA-link">
                        <a [routerLink]="guestPaymentState"
                           tid="editPaymentAddressNumbers"
                           id="editPaymentAddressNumbers">
                            <span>{{paymentRequest.property.address.line1}}</span>
                            <span *ngIf="displayUnitNumber">Unit # </span>
                            <span>{{paymentRequest.property.address.unit}}</span><br />
                            <span>{{paymentRequest.property.address.line2}}</span>
                        </a>
                    </div>
                    <div class="u-block">
                        <a [routerLink]="guestPaymentState"
                           tid="editPaymentAddressCityStateZip"
                           id="editPaymentAddressCityStateZip">
                            <span>{{paymentRequest.property.address.city}}, </span>
                            <span>{{paymentRequest.property.address.state}} </span>
                            <span>{{paymentRequest.property.address.postalCode}}</span>
                        </a>
                    </div>
                    <a class="u-inlineBlock u-pT2"
                       [routerLink]="guestPaymentState"
                       tid="editPaymentAddressLink"
                       id="editPaymentAddressLink">
                        Edit
                    </a>
                </div>
            </div>
            <div class="u-pB5">
                <button name="cancel"
                        id="cancel"
                        tid="cancel"
                        class="Button Button--link HOA-make-payment-button"
                        type="button"
                        (click)="onCancel()">
                    Cancel
                </button>
                <button name="submit" id="submit" tid="submit" class="Button Button--blue" type="submit"
                        [ifOverFlowXClass]="'Button--overflowX'" (click)="submit()" [disabled]="isPaymentSubmitted">
                    Submit Payment
                </button>
            </div>
            <div *ngIf="paymentRequest && !paymentRequest.futureDatedPayment"
                 tid="confirmationText" id="confirmationText" class="u-pT2">
                A confirmation email will be sent to email address {{ homeowner.contactInformation.email.value }}.
            </div>
        </div>
    </div>
</app-page-content>
`;
// Exports
module.exports = code;